module.exports = __webpack_public_path__ + "static/langojango-igbo-language-phrasebook-f56db980eaa58de77b61c5a722688afe.png";